import { render } from "./AddView.vue?vue&type=template&id=f0ae9b72&scoped=true"
import script from "./AddView.vue?vue&type=script&lang=js"
export * from "./AddView.vue?vue&type=script&lang=js"

import "./AddView.vue?vue&type=style&index=0&id=f0ae9b72&scoped=true&lang=css"

import exportComponent from "C:\\Users\\rh\\Documents\\GitHub\\handover-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0ae9b72"]])

export default __exports__